import React                        from 'react'
import Drawer                       from '@mui/material/Drawer';

import { Typography                } from 'src/components/common/typography';
import { Button                    } from 'src/components/common/button';
import { Checkbox                  } from 'src/components/common/checkbox';

import { ActionsContainer, 
         AttentionDialogVariants, 
         CheckboxContainer, 
         Container, 
         InfoContainer,       
         attention_dialog_variants } from 'src/components/features/main/attention-dialog/ui';

import { storeApi, 
         useAppDispatch, 
         useAppSelector            } from 'src/store';

type Props = {
  isOpened: boolean; 
  variant: AttentionDialogVariants;
}



export const AttentionDialog: React.FC<Props> = ( {
    isOpened,
    variant = 'attention_dialog_main'
} ) => {
  const lookAndFeel = attention_dialog_variants.get(variant)!;

  const isChecked = useAppSelector(storeApi.main.mainAttentionDialog.selectors.selectIsChecked)
  const dispatch = useAppDispatch();
  
  const handleTap = () => {
    dispatch(storeApi.main.mainAttentionDialog.action.setIsOpened());
  }

  const handleChange = (value: boolean) => {
    dispatch(storeApi.main.mainAttentionDialog.action.setIsChecked(value));
  }

  return (
    <Drawer
      anchor = 'bottom'
      open = { isOpened }
    >
        <Container lookAndFeel = { lookAndFeel }>
            <InfoContainer lookAndFeel = { lookAndFeel }>
                <Typography variant='blackw400s16lh22'>Внимание!</Typography>
                <Typography variant='blackw400s14lh20'>
                    Сервис носит информационный характер и не является инструментом аттестации. 
                    Точность подсчета зависит от фото продукции, полученный результат рекомендуется
                    проверить визуально.
                </Typography>
            </InfoContainer>

            <ActionsContainer lookAndFeel = { lookAndFeel }>
                <CheckboxContainer lookAndFeel = { lookAndFeel }>
                    <Checkbox label='Больше не показывать' variant={'h24bluetextround'} value={isChecked} onChange={ handleChange }/>
                </CheckboxContainer>
                <Button variant='h48bluefillrounnd' onTap={handleTap} label='Закрыть'/>
            </ActionsContainer>
        </Container>
      
    </Drawer>
  )
}
